// HATV section Leader Details API

import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

interface HATVAboStatisticParams {
  affiliateCode: String | Number;
  aboNumber: String | Number;
  closingMonth: String | Number;
}

interface userNativeParams {
  nativeId: String;
}

export interface HATVABOStatDetailsValueItem<T extends number | string = number> {
  closingMonth: string;
  value: T;
}

export interface HATVAboStatisticDetails {
  closingMonth: string;
  leaderStatisticDetail: {
    performanceBonusPercentage: HATVABOStatDetailsValueItem[];
    groupSize: HATVABOStatDetailsValueItem[];
    contributorCount: HATVABOStatDetailsValueItem[];
    activeCustomerCount: HATVABOStatDetailsValueItem[];
    groupPv: HATVABOStatDetailsValueItem[];
    rubyPv: HATVABOStatDetailsValueItem[];
    qLeg: HATVABOStatDetailsValueItem[];
    qType: Array<
      HATVABOStatDetailsValueItem<string> & {
        qvUsed: {
          affiliateCode: string;
          aboNumber: string;
          name: string;
          localName: string;
        };
      }
    >;
    personalPvDetail: {
      personalPv: HATVABOStatDetailsValueItem[];
      topUpPv: HATVABOStatDetailsValueItem[];
      vcs: HATVABOStatDetailsValueItem[];
      vcsPercentage: HATVABOStatDetailsValueItem[];
      customerPv: HATVABOStatDetailsValueItem[];
      customerPvPercentage: HATVABOStatDetailsValueItem[];
    };
  };
}
export const hatvAboStatisticAPI = createApi({
  reducerPath: 'HATVAboStatisticAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  tagTypes: ['abostatistic'],
  endpoints: (builder) => ({
    getHATVAboStatistic: builder.query<any, HATVAboStatisticParams>({
      query: ({ closingMonth, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/abostatistic/summary/month/${closingMonth}`,
        method: 'GET',
      }),
    }),
    getHATVAboStatisticDetails: builder.query<
      { body: HATVAboStatisticDetails },
      HATVAboStatisticParams
    >({
      query: ({ closingMonth, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/qmonthapproval/abostatistic/detail/month/${closingMonth}`,
        method: 'GET',
      }),
    }),
    getUserNameWithID: builder.query<any, userNativeParams>({
      query: ({ nativeId }) => ({
        url: `/auth/user/native/${nativeId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyGetHATVAboStatisticQuery,
  useGetHATVAboStatisticDetailsQuery,
  useLazyGetUserNameWithIDQuery,
} = hatvAboStatisticAPI;
